import type { FC, ComponentProps } from "react";
import classNames from "classnames";

import Flare from "./flare";

import classes from "./style.module.scss";

import { ReactComponent as IconArrow } from "./icons/right-arrow.svg";
import { useRemoteConfig } from "@web-solutions/base-app/hooks/use-remote-config";

interface BaseButtonProps {
  id?: string;
  onClick?: (x: any) => void;
  title: string | React.ReactElement;
  disabled?: boolean;
  className?: string;
  type?: "button" | "submit" | "reset";
  flare?: boolean;
  titleClassName?: string;
  iconRight?: boolean;
}

export interface ButtonProps
  extends Omit<ComponentProps<"button">, keyof BaseButtonProps>,
    BaseButtonProps {}

const Button: FC<ButtonProps> = ({
  id,
  onClick,
  title,
  disabled = false,
  className = null,
  type = "button",
  flare = false,
  titleClassName = null,
  iconRight = false,
  ...props
}) => {
  
  return (
    <button
      id={id}
      type={type}
      onClick={onClick}
      className={classNames(classes.button, className)}
      disabled={disabled}
      {...props}
    >
      <div className={classNames(classes.button__title, titleClassName)}>
        <span>{title}</span>
      </div>
      {iconRight && <IconArrow className={classes["button__right-icon"]} />}
      {!disabled && flare ? <Flare /> : null}
    </button>
  );
};
export default Button;